/* Customer-controlled media. No third-party player loads before a click. */
if (!customElements.get('relaxway-video')) {
  customElements.define('relaxway-video', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const button = this.querySelector('button');
      const template = this.querySelector('template');
      if (!button || !template) return;
      button.addEventListener('click', () => {
        const player = template.content.firstElementChild.cloneNode(true);
        document.querySelectorAll('video').forEach(video => video.pause());
        button.replaceWith(player);
        player.focus();
      }, {once: true});
    }
  });
}
function initialiseRelaxwayCarousels(scope = document) {
  scope.querySelectorAll('[data-rlx-carousel]').forEach(root => {
    if (root.dataset.rlxReady) return;
    root.dataset.rlxReady = 'true';
    const track = root.querySelector('[data-rlx-track]');
    const previous = root.querySelector('[data-rlx-prev]');
    const next = root.querySelector('[data-rlx-next]');
    if (!track || !previous || !next) return;
    const update = () => {
      root.querySelector('.rlx-carousel-controls').hidden = track.scrollWidth <= track.clientWidth + 2;
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const scroll = direction => track.scrollBy({left: direction * (track.firstElementChild?.getBoundingClientRect().width + 16 || track.clientWidth * .85), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    previous.addEventListener('click', () => scroll(-1));
    next.addEventListener('click', () => scroll(1));
    track.addEventListener('scroll', update, {passive: true});
    new ResizeObserver(update).observe(track);
    update();
  });
}
initialiseRelaxwayCarousels();
document.addEventListener('shopify:section:load', event => initialiseRelaxwayCarousels(event.target));
